import { render, staticRenderFns } from "./Dowel.vue?vue&type=template&id=62238b44&"
import script from "./Dowel.vue?vue&type=script&lang=js&"
export * from "./Dowel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports